"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import MeasurementTrendChart from "@/components/patient/measurements/trend-chart";
import type { MeasurementAggregationRule, MeasurementBucketGranularity } from "@/lib/measurement-aggregation";
import type { MeasurementDataType, MeasurementGoal, ReferenceRange } from "@/types/measurement";
import FieldTogglePills from "./field-toggle-pills";
interface TrendField {
  id: string;
  name: string;
  unit?: string | null;
  color: string;
  referenceRanges?: ReferenceRange[];
  dataType?: MeasurementDataType;
  decimalPlaces?: number | null;
}
interface TrendChartsSectionProps {
  patientId: string;
  fields: TrendField[];
  latestGoals: Map<string, MeasurementGoal>;
  /** Set to false to hide the section (e.g. not enough data) */
  enabled?: boolean;
  /** Time bucket the enclosing card is showing, so trends agree with it. */
  granularity?: MeasurementBucketGranularity;
  rule?: MeasurementAggregationRule;
}
export default function TrendChartsSection(t0) {
  const $ = _c(18);
  const {
    patientId,
    fields,
    latestGoals,
    enabled: t1,
    granularity: t2,
    rule: t3
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const granularity = t2 === undefined ? "DAY" : t2;
  const rule = t3 === undefined ? "LATEST" : t3;
  const [expanded, setExpanded] = useState(false);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Set();
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const [selectedFields, setSelectedFields] = useState(t4);
  let t5;
  let t6;
  if ($[1] !== enabled || $[2] !== expanded || $[3] !== fields || $[4] !== granularity || $[5] !== latestGoals || $[6] !== patientId || $[7] !== rule || $[8] !== selectedFields) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const uniqueFields = fields.filter(_temp);
      if (!enabled || uniqueFields.length === 0) {
        t6 = null;
        break bb0;
      }
      const handleToggleExpand = () => {
        if (!expanded && selectedFields.size === 0) {
          const first = uniqueFields[0];
          if (first) {
            setSelectedFields(new Set([first.id]));
          }
        }
        setExpanded(!expanded);
      };
      let t7;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = fieldId => {
          setSelectedFields(prev => {
            const next = new Set(prev);
            if (next.has(fieldId)) {
              next.delete(fieldId);
            } else {
              next.add(fieldId);
            }
            return next;
          });
        };
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      const handleToggleField = t7;
      const pillFields = uniqueFields.map(_temp2);
      let t8;
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <span>Trend Charts</span>;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      let t9;
      if ($[13] !== expanded) {
        t9 = expanded ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />;
        $[13] = expanded;
        $[14] = t9;
      } else {
        t9 = $[14];
      }
      let t10;
      if ($[15] !== handleToggleExpand || $[16] !== t9) {
        t10 = <button type="button" className="flex w-full items-center justify-between px-4 py-2 text-caption-strong text-foreground-secondary hover:bg-hover" onClick={handleToggleExpand}>{t8}{t9}</button>;
        $[15] = handleToggleExpand;
        $[16] = t9;
        $[17] = t10;
      } else {
        t10 = $[17];
      }
      t5 = <div className="border-t border-border space-y-2">{t10}{expanded && <div className="space-y-4 px-4 pb-4"><FieldTogglePills fields={pillFields} selected={selectedFields} onToggle={handleToggleField} />{uniqueFields.filter(f_0 => selectedFields.has(f_0.id)).map(field_0 => {
            const fieldGoal = latestGoals.get(field_0.id);
            return <div key={field_0.id}><p className="mb-1 text-caption-strong text-foreground-secondary">{field_0.name}{field_0.unit && <span>{` (${field_0.unit})`}</span>}</p><MeasurementTrendChart patientId={patientId} fieldId={field_0.id} fieldName={field_0.name} unit={field_0.unit} color={field_0.color} referenceRanges={field_0.referenceRanges} goal={fieldGoal} dataType={field_0.dataType} decimalPlaces={field_0.decimalPlaces} granularity={granularity} rule={rule} /></div>;
          })}</div>}</div>;
    }
    $[1] = enabled;
    $[2] = expanded;
    $[3] = fields;
    $[4] = granularity;
    $[5] = latestGoals;
    $[6] = patientId;
    $[7] = rule;
    $[8] = selectedFields;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  return t5;
}
function _temp2(f) {
  return {
    id: f.id,
    name: f.name,
    color: f.color
  };
}
function _temp(field, index, allFields) {
  return allFields.findIndex(candidate => candidate.id === field.id) === index;
}